import { Table, Typography } from "antd";

const { Title } = Typography;

const format = (v) =>
  `₹${Number(v ?? 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
  })}`;

const PurchaseReturnGSTR2Table = ({
  data = [],
  loading = false,
  printMode = false,
}) => {
  const columns = [
    { title: "Description", dataIndex: "label" },
    { title: "IGST Amount", dataIndex: "igst", align: "right", render: format },
    { title: "CGST Amount", dataIndex: "cgst", align: "right", render: format },
    { title: "SGST Amount", dataIndex: "sgst", align: "right", render: format },
    { title: "Taxable Amount", dataIndex: "taxable", align: "right", render: format },
    { title: "Bill Total", dataIndex: "total", align: "right", render: format },
  ];

  return (
    <>
      <Title level={5}>Purchase Return GSTR-2 Summary</Title>

      <Table
        loading={loading}
        columns={columns}
        dataSource={data}
        pagination={false}
        bordered
        rowKey="key"
        scroll={printMode ? undefined : { x: "max-content" }}
      />
    </>
  );
};

export default PurchaseReturnGSTR2Table;